import axios from "axios";
import errorResponseHandler from "./errorResponseHandler";
import { store } from "../../Store/Reducers";

const API = axios.create({ baseURL: process.env.REACT_APP_HOST });

API.interceptors.request.use((req) => {
  const tokenString = sessionStorage.getItem("sb-wnpukijoybwfgrpearge-auth-token");
  const token = tokenString ? JSON.parse(tokenString) : null;

  const state = store.getState();
  const { stateNearestDrivers } = state.bookingReducer;

  if (token?.access_token) {
    req.headers.Authorization = `Bearer ${token.access_token}`;
  } else if (stateNearestDrivers?.access_token) {
    req.headers.Authorization = `Bearer ${stateNearestDrivers.access_token}`;
  }

  const pathParts = window.location.pathname.split("/");
  const apiKeyIndex = pathParts.indexOf("apiKey");
  const apiKey = apiKeyIndex !== -1 ? pathParts[apiKeyIndex + 1] : null;

  if (apiKey) req.headers["x-api-key"] = apiKey;

  return req;
});

API.interceptors.response.use(
  (response) => response,
  errorResponseHandler
);

export default API;
